export const AI_LOG_DISCARDED = 0
export const AI_LOG_CREATED = 1

export const AI_LOG_FAILED = 0
export const AI_LOG_SUCCESS = 1

export const AddressType = {
  SHIPPING_ADDRESS: 'shipping_address',
  BILLING_ADDRESS: 'billing_address',
}

export const channelsType = {
  ALERT: 'ALERT',
  SMS_ALERT: 'SMS_ALERT',
  EMAIL_ALERT: 'EMAIL_ALERT',
  SOCIAL_ALERT: 'SOCIAL_ALERT',
  AUTOMATED_CALL_ALERT: 'AUTOMATED_CALL_ALERT',
  BEACON_ALERT: 'BEACON_ALERT',
}

export const channelsFormatMessage = {
  ALERT: 'messageSringApp',
  SMS_ALERT: 'sms',
  EMAIL_ALERT: 'email',
  SOCIAL_ALERT: 'socialMedia',
  AUTOMATED_CALL_ALERT: 'automatedCall',
  BEACON_ALERT: 'beacon',
}

export const filterType = {
  ALL: 'ALL',
  TODAY: 'TODAY',
  LAST_SEVEN_DAYS: 'LAST_SEVEN_DAYS',
  LAST_THIRTY_DAYS: 'LAST_THIRTY_DAYS',
  LAST_SIX_MONTHS: 'LAST_SIX_MONTHS',
  LAST_YEAR: 'LAST_YEAR',
}

export const creditAi = {
  GENERATE_CONTENT: 'GENERATE_CONTENT',
  GENERATE_IMAGE: 'GENERATE_IMAGE',
  TEXT_SUMMARIZE: 'TEXT_SUMMARIZE',
  TEXT_REVISE: 'TEXT_REVISE',
  TEXT_RATING: 'TEXT_RATING',
}

export const BRAINTREE_CASH = 'cash'

export const filterResultType = {
  DAYS: 'days',
  MONTHS: 'months',
}

export const filters = (formatMessage) => [
  {
    id: 1,
    key: filterType.ALL,
    label: formatMessage({
      id: 'planAndBilling.filter.all.label',
    }),
  },
  {
    id: 2,
    key: filterType.TODAY,
    label: formatMessage({
      id: 'planAndBilling.filter.today.label',
    }),
  },
  {
    id: 3,
    key: filterType.LAST_SEVEN_DAYS,
    label: formatMessage({
      id: 'planAndBilling.filter.week.later.label',
    }),
  },
  {
    id: 4,
    key: filterType.LAST_THIRTY_DAYS,
    label: formatMessage({
      id: 'planAndBilling.filter.month.later.label',
    }),
  },
  {
    id: 5,
    key: filterType.LAST_SIX_MONTHS,
    label: formatMessage({
      id: 'planAndBilling.filter.sixMonth.later.label',
    }),
  },
  {
    id: 6,
    key: filterType.LAST_YEAR,
    label: formatMessage({
      id: 'planAndBilling.filter.year.later.label',
    }),
  },
]

export const aiLogFilterStatus = [
  {
    id: AI_LOG_CREATED,
    name: 'created',
    label: 'created.label',
    checked: false,
  },
  {
    id: AI_LOG_DISCARDED,
    name: 'discarded',
    label: 'discarded.label',
    checked: false,
  },
]
